
import React, { useState, useEffect } from 'react';
import { SessionRegistration } from './SessionRegistration'; // Adjust the import path as necessary

export const SessionHistory = ({ sessionData, totalCount, onSort, onShowMore, loading, error, sort, sortDirection }) => {
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const [selectedSession, setSelectedSession] = useState(null);
    const [selectedSlotStatus, setSelectedSlotStatus] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);

    const handleEditClick = (session, slot) => {
        setSelectedSession(session);
        setSelectedSlotStatus(slot.status);
        setIsEditMode(true);
        setShowRegistrationModal(true);
    };

    const parseDaysLeft = (daysLeft) => {
        if (daysLeft === "Past") return -1;
        if (typeof daysLeft === "string" && daysLeft.includes("days")) {
            return parseInt(daysLeft.split(" ")[0], 10);
        }
        if (typeof daysLeft === "string" && daysLeft.includes("month")) {
            return 30; // Approximate a month as 30 days
        }
        return 999; // Future date
    };

    const getSortIcon = (column) => {
        if (sort === column) {
            return sortDirection === 'asc' ? "/Images/Sort-up.svg" : "/Images/sort-icon.svg";
        }
        return "/Images/sort-icon.svg";
    };

    return (
        <div>
            {sessionData && sessionData.length > 0 ? (
                <>
                    <table className="table bg-white hive-grid mb-3 table-borderless">
                        <thead className="hive-table-head">
                            <tr>
                                <th className="bold-text font-12" onClick={() => onSort('session_name')}>
                                    Session Name
                                    <span className="ps-2">
                                        <img src={getSortIcon('session_name')} alt="Sorticon" className="hive-table-sort" />
                                    </span>
                                </th>
                                <th className="bold-text font-12" onClick={() => onSort('session_date')}>
                                    Session Date
                                    <span className="ps-2">
                                        <img src={getSortIcon('session_date')} alt="Sorticon" className="hive-table-sort" />
                                    </span>
                                </th>
                                <th className="bold-text font-12" onClick={() => onSort('start_time')}>
                                    Timings
                                    <span className="ps-2">
                                        <img src={getSortIcon('start_time')} alt="Sorticon" className="hive-table-sort" />
                                    </span>
                                </th>
                                <th className="bold-text font-12" onClick={() => onSort('duration')}>
                                    Duration
                                    <span className="ps-2">
                                        <img src={getSortIcon('duration')} alt="Sorticon" className="hive-table-sort" />
                                    </span>
                                </th>
                                <th className="bold-text font-12" onClick={() => onSort('days_left')}>
                                    Days Left
                                    <span className="ps-2">
                                        <img src={getSortIcon('days_left')} alt="Sorticon" className="hive-table-sort" />
                                    </span>
                                </th>
                                <th className="bold-text font-12" onClick={() => onSort('status')}>
                                    Status
                                    <span className="ps-2">
                                        <img src={getSortIcon('status')} alt="Sorticon" className="hive-table-sort" />
                                    </span>
                                </th>
                                <th className="text-center bold-text font-12">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sessionData.map((session) => {
                                const filteredSlots = session.slots.filter(slot => slot.status);

                                return filteredSlots.length > 0 ? (
                                    filteredSlots.map((slot, index) => {
                                        // Determine status and classes based on conditions
                                        let statusClass = '';
                                        let statusText = slot.status;
                                        let displayDaysLeft = slot.days_left;

                                        if (slot.days_left == "Past") {
                                            statusClass = 'completed';
                                            statusText = 'Completed';
                                            displayDaysLeft = 'NIL'; // Show NIL for past sessions
                                        } else if ((slot.status === 'Register' || slot.status === 'Reschedule') && !slot.is_active) {
                                            statusClass = 'cancelled';
                                            statusText = 'Cancelled';
                                            slot.days_left = 'NIL'; // Show NIL for cancelled sessions
                                        } else if (slot.status === 'Register') {
                                            statusClass = 'registered';
                                            statusText = 'Registered';
                                        } else if (slot.status === 'Reschedule') {
                                            statusClass = 'rescheduled';
                                            statusText = 'Rescheduled';
                                        } else if (slot.is_active == false) {
                                            statusClass = 'cancelled';
                                            statusText = 'Cancelled';
                                        }
                                        const isDisabled = !(slot.status === 'Register' && slot.days_left !== "Past" && parseDaysLeft(slot.days_left) >= 7);

                                        return (
                                            <tr key={slot.slot_id} className={`hive-table-data regular-text align-middle`}>
                                                {index === 0 && (
                                                    <td rowSpan={filteredSlots.length}>{session.session_name}</td>
                                                )}
                                                <td>{slot.session_date}</td>
                                                <td>{slot.start_time} - {slot.end_time}</td>
                                                <td>{slot.duration}</td>
                                                <td>{displayDaysLeft}</td>
                                                <td><span className={`font-12 medium-text status-badge ${statusClass}`}>{statusText}</span></td>
                                                <td className="text-center">
                                                    <button
                                                        disabled={isDisabled}
                                                        onClick={() => !isDisabled && handleEditClick(session, slot)}
                                                        className="bg-transparent border-0 pe-0"
                                                    >
                                                        <img src={isDisabled ? "Images/disabled-edit-icon.svg" : "Images/edit-action.svg"} alt="edit" />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : null;
                            })}
                        </tbody>
                    </table>

                    {/* Pagination and Load More Button */}
                    <p className="font-12 pagination">
                        Showing <span className="bold-text mx-1">{sessionData.length}</span> of
                        <span className="bold-text mx-1">{totalCount}</span> Records
                    </p>

                    {/* Show More Button only if total records are 10 or more */}
                    {totalCount > 10 && sessionData.length < totalCount && (
                        <div className="text-center">
                            <button className="btn show-more-btn" onClick={onShowMore}>
                                Show More
                            </button>
                        </div>
                    )}

                    {/* Session Registration Modal */}
                    {showRegistrationModal && selectedSession && (
                        <SessionRegistration
                            session={selectedSession}
                            onClose={() => setShowRegistrationModal(false)}
                            isEditMode={isEditMode}
                            status={selectedSlotStatus}
                        />
                    )}
                </>
            ) : (
                <div className="row">
                    <div className="d-flex flex-column align-items-center justify-content-center container-height">
                        <img className="empty-img-width mb-4" src="Images/table-empty-state.svg" alt="empty-state" />
                        <p className="font-14 medium-text grey-text mb-1">No History Yet</p>
                    </div>
                </div>
            )}
        </div>
    );
};
